module.exports = __webpack_public_path__ + "static/media/banner.da5c800c.jpg";